module.exports = __webpack_public_path__ + "img/rule-content-en.1c9d5eb2.png";